import React from "react";
import { getRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";

const { DateTime } = require("luxon");

class RakutenMerchantData extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            merchants: [],
            merchantsLoading: false,
            MerchantsTable: {
                title: "Affiliate merchants",
                options: {
                    selectableRows: "multiple",
                    rowsPerPage: 100,
                    sortOrder: {
                        name: 'merchantName',
                        direction: 'asc'
                    },
                },
                getTheme: () => createTheme({
                    typography: {
                        fontFamily: "'Urbanist', 'sf_pro_displayregular', sans-serif",
                    },
                    overrides: {
                        MUIDataTableBodyRow: {
                            root: {
                                '&:nth-child(odd)': {
                                    backgroundColor: '#F9F9F9'
                                },
                                cursor: 'pointer'
                            }
                        },
                    }
                })
            },
        };
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
        this.getMerchants();
    };

    getMerchants = async () => {
        let url = `/api/Merchant/GetRakutenMerchants`;

        this.setState({ merchantsLoading: true });

        try {
            const merchants = await getRequest(url);

            this.setState({
                merchants,
                merchantsLoading: false,
            });
        } catch (error) {
            console.error("Error fetching merchants:", error);
            this.setState({ merchants: [], merchantsLoading: false });
        }
    };

    onTabChange = (tab) => {
        this.setState({ tab });
    }

    render() {
        const columns = [
            {
                name: "advertiserName",
                label: "Advertiser Name",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "hostname",
                label: "Hostname",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "advertiserUrl",
                label: "Advertiser URL",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "merchantID",
                label: "Merchant ID",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
            name: "advertiserDescription",
            label: "Advertiser Description",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <div
                        style={{
                            maxWidth: "200px",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis"
                        }}
                        title={value} // Full text on hover
                    >
                        {value}
                    </div>
                    )
                }
            },
            {
                name: "linkToTermsAndConditions",
                label: "Terms & Conditions",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "linkToProgramHistory",
                label: "Program History",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "linkToHomePage",
                label: "Home Page",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "status",
                label: "Status",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "contactName",
                label: "Contact Name",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "contactTitle",
                label: "Contact Title",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "state",
                label: "State",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "city",
                label: "City",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "address",
                label: "Address",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "zip",
                label: "Zipcode",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "county",
                label: "Country",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "phone",
                label: "Phone",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "emailAddress",
                label: "Email Address",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <a href={`mailto:${value}`}>{value}</a>
                    )
                }
            },
           {
            name: "commissionTerms",
            label: "Commission Terms",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <div
                        style={{
                            whiteSpace: "pre-wrap",
                            maxWidth: "400px",
                            minWidth: "300px",
                        }}
                        title={value} // Full text on hover
                    >
                        {value}
                    </div>
                    )
                }
            },
            {
                name: "offer",
                label: "Offer",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <p style={{ textAlign: "center", margin: 0 }}>
                            {value ? `${value}%` : "-"}
                        </p>
                    )
                }
            },
            {
                name: "offerType",
                label: "Offer Type",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "yearJoined",
                label: "Year Joined",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "expirationDate",
                label: "Expiration Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <span>{!!(value) ? value.slice(0, value.indexOf(" ")).trim() : "-"}</span>
                    )
                }
            },
            {
                name: "returnDays",
                label: "Return Days",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <p style={{ textAlign: "center", margin: 0 }}>
                            {value ? `${value} days` : "-"}
                        </p>
                    )
                }
            },
            {
                name: "transactionUpdateWindow",
                label: "Phone",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "trueLock",
                label: "True Lock",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "premiumStatus",
                label: "Premium Status",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "baselineCommissionTerms",
                label: "Baseline Commission Terms",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <div
                            style={{
                                whiteSpace: "pre-wrap",
                                maxWidth: "400px",
                                minWidth: "300px",
                            }}
                            title={value} // Full text on hover
                        >
                            {value}
                        </div>
                    )
                }
            },
            {
                name: "baselineOffer",
                label: "Baseline Offer",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "baselineOfferType",
                label: "Baseline Offer Type",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "baselineExpirationDate",
                label: "Baseline Expiration Date",
                options: {
                    filter: true,
                    sort: true,
                    customBodyRender: (value) => (
                        <span>{!!(value) ? value.slice(0, value.indexOf(" ")).trim() : "-"}</span>
                    )
                }
            },
            {
                name: "baselineReturnDays",
                label: "Baseline Return Days",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "baselineTransactionUpdateWindow",
                label: "Phone",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "baselineTrueLock",
                label: "Baseline True Lock",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "network",
                label: "Network",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "crossDeviceEnabeld",
                label: "Cross Device Enabled",
                options: {
                    filter: true,
                    sort: true
                }
            },
            {
                name: "itpCompliant",
                label: "ITP Compliant",
                options: {
                    filter: true,
                    sort: true
                }
            },
];


        return (
            <div>
                <ThemeProvider theme={this.state.MerchantsTable.getTheme()}>
                    <MUIDataTable
                        title={
                            <div style={{ fontFamily: "'Urbanist', sans-serif" }}>
                                <p style={{ fontSize: '22px', marginTop: "20px" }}>{this.props.affiliateProgramManager?.name + " merchants" ?? "No affiliate selected"}</p>
                            </div>
                        }
                        data={this.state.merchants}
                        columns={columns}
                        options={{
                            ...this.state.MerchantsTable.options,
                            textLabels: {
                                body: { noMatch: this.state.merchantsLoading ? "LOADING..." : "No data available" },
                            },
                            selectableRows: "none",
                        }}
                        ref={this.tableRef}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

export default RakutenMerchantData;
